import React, { useState } from "react";

export default function SelectPopup(props) {
  const { options, values, handleChange } = props;

  let col1 = [];
  let col2 = [];

  let cols = [];
  let colsnumber = Math.ceil(options.length / 20);

  for (let i = 0; i < colsnumber; i++) {
    cols.push([]);
  }

  if (options.length > 0) {
    for (let i = 0; i < options.length; i++) {
      cols[i % colsnumber].push(options[i]);
    }
  }

  console.log(cols);

  if (options.length > 0) {
    for (let i = 0; i < Math.ceil(options.length / 2); i++) {
      col1.push(options[i]);
    }
    for (let i = Math.ceil(options.length / 2); i < options.length; i++) {
      col2.push(options[i]);
    }
  }

  let tmpvalues = [];
  console.log(values);
  for (let i = 0; i < values.length; i++) {
    tmpvalues.push(values[i]);
  }

  return (
    <div className="optiondisplayouter">
      <div className="optiondisplayinner">
        <div style={{ display: "flex" }}>
          {cols.map((ob, i) => {
            return (
              <div style={{ flexGrow: "1" }}>
                {ob.map((o, idx) => {
                  return (
                    <div
                      key={idx}
                      className="optiondisplaysecondcol"
                      onClick={() => {
                        if (
                          tmpvalues.filter((obj) => obj.value === o.value)
                            .length > 0
                        ) {
                          tmpvalues = tmpvalues.filter(
                            (obj) => obj.value !== o.value
                          );
                        } else {
                          tmpvalues.push(o);
                        }
                        handleChange(tmpvalues);
                      }}
                    >
                      <input
                        readOnly
                        className="cruisecheckbox"
                        checked={
                          tmpvalues.filter((obj) => {
                            return obj.value === o.value;
                          }).length > 0
                        }
                        type="checkbox"
                      ></input>
                      {ob[idx].label}
                    </div>
                  );
                })}
              </div>
            );
          })}
          {/*         {col1.length > 0 && (
            <div style={{ flexGrow: "1" }}>
              {col1.map((o, i) => {
                return (
                  <div
                    key={i}
                    className="optiondisplayfirstcol"
                    onClick={() => {
                      if (
                        tmpvalues.filter((obj) => obj.value === o.value)
                          .length > 0
                      ) {
                        tmpvalues = tmpvalues.filter(
                          (obj) => obj.value !== o.value
                        );
                      } else {
                        tmpvalues.push(o);
                      }
                      handleChange(tmpvalues);
                    }}
                  >
                    <input
                      readOnly
                      className="cruisecheckbox"
                      checked={
                        tmpvalues.filter((obj) => {
                          return obj.value === o.value;
                        }).length > 0
                      }
                      type="checkbox"
                    ></input>
                    {col1[i].label}
                  </div>
                );
              })}
            </div>
            )}*/}
          {/*col2.length > 0 && (
            <div style={{ flexGrow: "1" }}>
              {col2.map((o, i) => {
                return (
                  <div
                    key={i}
                    className="optiondisplaysecondcol"
                    onClick={() => {
                      if (
                        tmpvalues.filter((obj) => obj.value === o.value)
                          .length > 0
                      ) {
                        tmpvalues = tmpvalues.filter(
                          (obj) => obj.value !== o.value
                        );
                      } else {
                        tmpvalues.push(o);
                      }
                      handleChange(tmpvalues);
                    }}
                  >
                    <input
                      readOnly
                      className="cruisecheckbox"
                      checked={
                        tmpvalues.filter((obj) => {
                          return obj.value === o.value;
                        }).length > 0
                      }
                      type="checkbox"
                    ></input>
                    {col2[i].label}
                  </div>
                );
              })}
            </div>
            )*/}
        </div>
      </div>
    </div>
  );
}
